import { Platform } from '@angular/cdk/platform';
import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FusePlatformService {
    private readonly platform = inject(Platform);
    private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    public osName = 'os-unknown';

    /**
     * Constructor
     */
    constructor() {
        // If the platform is not a browser, return immediately
        if (!this.isBrowser) {
            return;
        }

        // Windows
        if (navigator.userAgent.includes('Win')) {
            this.osName = 'os-windows';
        }

        // Mac OS
        if (navigator.userAgent.includes('Mac')) {
            this.osName = 'os-mac';
        }

        // Unix
        if (navigator.userAgent.includes('X11')) {
            this.osName = 'os-unix';
        }

        // Linux
        if (navigator.userAgent.includes('Linux')) {
            this.osName = 'os-linux';
        }

        // iOS
        if (this.platform.IOS) {
            this.osName = 'os-ios';
        }

        // Android
        if (this.platform.ANDROID) {
            this.osName = 'os-android';
        }
    }
}
